import { Component, EventEmitter, OnInit, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lms-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropdownComponent),
      multi: true
    }
  ]
})
export class SelectDropdownComponent implements OnInit {
  @Output() change = new EventEmitter<Object>();
  @Input() items: Array<any>;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() selectedItem: any = null;
  @Input() size: any = null;
  @Input() label: any = '';
  @Input() placeholder: any = '';

  constructor() {}

  public ngOnInit(): void {}

  public onChange(value: CustomEvent | any): void {
    const newValue = value?.objValues?.values[0] || value?.value;
    this.selectedItem = newValue;
    this.change.emit(newValue);
  }
}
